import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../actions/index';
import FiberManualRecordRoundedIcon from '@material-ui/icons/FiberManualRecordRounded';

function NavbarMenuLinks({ title, icon, path, click, isAllShops, closed, completed, key }) {
  return (
    <>
      {click ? (
        <div onClick={click} className={`topbar__link ${title && title.length > 25 && 'topbar__link-wrap'}`} >
          <span
            className={`topbar__link-icon lnr lnr-${icon} ${isAllShops && 'font-weight-bold'}`}
          />

          <p id='menu-link' className='topbar__link-title'>
            {title}
          </p>
          {!isAllShops && icon !== 'exit' &&
            <div className={`topbar__link-closed ${!closed ? completed ? 'open-color' : 'uncompleted-color' : 'closed-color'} ${title && title.length > 25 && 'link-top'}`}>
              <FiberManualRecordRoundedIcon className='topbar__link-closed-icon' />
              <span className='topbar__link-text'>{!closed ? completed ? 'Ouvert' : 'Inactif' : 'Fermé'}</span>
            </div>}
        </div>
      ) : <Link className='topbar__link' to={path} key={key}>
        <span className={`topbar__link-icon lnr lnr-${icon}`} />
        <p className='topbar__link-title'>{title}</p>
      </Link>}

    </>
  );
}

function mapStateToProps({ user, firebaseRealTime }) {
  const { generalConfig = {} } = firebaseRealTime;
  const { shopName } = user;
  const { logoUrl } = generalConfig;
  return {
    shopName,
    logoUrl
  };
}

export default connect(mapStateToProps, actions)(NavbarMenuLinks);
